import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {SharedModule} from "../shared/shared.module";
import {ConfigurationRoutingModule} from "./configuration-routing.module";
import {FlexModule} from "@angular/flex-layout";

@NgModule({
  declarations: [
    ConfigurationRoutingModule.components,
    ],
  imports: [
    CommonModule,
    ConfigurationRoutingModule,
    SharedModule,
    FlexModule
  ],
    exports: [],
})
export class ConfigurationModule { }
